import Http from "./http";

export const getSystemCampaignStatusAPI = (payload) => {
  return Http.post("admin/campaign/system-campaign-status", payload);
};
